var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18181B",
    d: "M12 12.25a8 8 0 0 1 7.999 7.86.5.5 0 0 1-.292.463A18.4 18.4 0 0 1 12 22.25c-2.75 0-5.361-.6-7.708-1.678A.5.5 0 0 1 4 20.11 8 8 0 0 1 12 12.25m0 1a7 7 0 0 0-6.987 6.549A17.4 17.4 0 0 0 12 21.25c2.484 0 4.845-.519 6.984-1.451A7 7 0 0 0 12 13.25m0-11.5a4.25 4.25 0 1 1 0 8.5 4.25 4.25 0 0 1 0-8.5m0 1a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5"
  })));
};
export default SvgUser;